import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import '@/assets/css/index.scss'
import '@/assets/css/index.scss'
import router from './router' //导入路由
import store from './store'
// import Swiper from 'swiper'
import Swiper, { Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'
Swiper.use([Navigation, Pagination]);

Vue.use(ElementUI);

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/assets/css/quillEditor.css'
 Vue.use(VueQuillEditor)

Vue.config.productionTip = false

new Vue({
  router,//挂载路由
  store,
  render: h => h(App),
}).$mount('#app')
